import type { Device } from "../api";
import { IconButton } from "./IconButton";
import { IconEdit, IconTrash } from "./icons";

export function DeviceList({
  devices,
  selectedId,
  onSelect,
  onEdit,
  onDelete,
}: {
  devices: Device[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  onEdit: (device: Device) => void;
  onDelete: (device: Device) => void;
}) {
  return (
    <ul className="device-list">
      {devices.map((d) => (
        <li key={d.id} className={selectedId === d.id ? "selected" : ""}>
          <button type="button" className="device-main" onClick={() => onSelect(d.id)}>
            <span className={`dot ${d.online ? "on" : "off"} ${d.is_active ? "" : "pending"}`} />
            <span>
              <strong>{d.label || d.serial_no}</strong>
              <em>
                {d.phone} · {d.sim_type.toUpperCase()}
                {!d.is_active ? " · pending" : ""}
              </em>
            </span>
          </button>
          <div className="row-actions">
            <IconButton label="Edit" onClick={() => onEdit(d)}>
              <IconEdit />
            </IconButton>
            <IconButton label="Delete" danger onClick={() => onDelete(d)}>
              <IconTrash />
            </IconButton>
          </div>
        </li>
      ))}
    </ul>
  );
}
